module.exports = __webpack_public_path__ + "img/welcomes-preview-current-empty.13ef7d1f.png";